module.exports = __webpack_public_path__ + "static/media/modal-close-mobile-black.df1a3de9.svg";